export default "__VITE_ASSET__df61cb03__"